export default __webpack_public_path__ + "static/media/No_Gender_Avatar.5f6bec53.svg";